import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'CITY_DISTRICT',
  queryKey: 'f_district',
  type: FILTER_TYPES.SEGMENTS,
  bucketify: (hotel) => {
    const bucketId = hotel?.geographical?.district?.id;
    const bucketName = hotel?.geographical?.district?.name;

    if (!bucketId || !bucketName) {
      return undefined;
    }

    return {
      bucketId,
      bucketName,
    };
  },
  onFilterValueUpdate: ({ optionId }, filterState) => {
    return filterState.setIn(['accordionState', optionId], false);
  },
  onFilterPanelClose: (filterState) => {
    return filterState.withMutations((s) => {
      const accordionState = s.get('accordionState');
      if (accordionState) {
        accordionState.forEach((isAccordionOpen, key) => {
          if (isAccordionOpen) {
            s.setIn(['accordionState', key], false);
          }
        });
      }
    });
  },
  isFilterActive: (finalState) => {
    return Object.keys(finalState?.values || {}).length;
  },
  decorateFinalState: (finalState) => {
    // Decorate with accordionState so we can keep track of what extra information is shown
    if (finalState) finalState.accordionState = {};
    Object.keys((finalState && finalState.values) || {}).forEach((optionId) => {
      finalState.accordionState[optionId] = false;
    });
  },
  toQuery: ({ optionId, value } = {}, filterStateValues) => {
    const query = {};
    if (filterStateValues) {
      filterStateValues.forEach((filterValue, key) => {
        if (filterValue?.value) {
          query[key] = true;
        }
      });
    }

    if (optionId) query[optionId] = value;
    const res = [];

    Object.keys(query).forEach((key) => {
      if (query[key]) {
        res.push(key);
      }
    });

    return res.length ? res.join('|') : undefined;
  },
  fromQuery: (rawQueryValue) => {
    if (!rawQueryValue || typeof rawQueryValue !== 'string') {
      return false;
    }

    const optionIds = rawQueryValue.split('|');
    const res = {};

    optionIds.forEach((optionId) => {
      res[optionId] = true;
    });

    // NB: Returning false will not convert invalid input
    return res;
  },
}));
